export default class TreeNode {
    constructor(data) {
        Object.assign(
            this,
            {
                id: null,

                name: null,
                parent: null,
                children: [],
                level: 0,

                leaf: true,

                node: {
                    // checked: 0,  // 没勾选 部分勾选 勾选
                    // open: false, // 打开子目录
                    // show: true, // 显示
                    // match: null,  // 高亮
                }
            },
            data
        );
    }

    format() {
        let rs = Object.assign({}, this);
        rs.node = null;
        delete rs.node;
        delete rs.children;
        return rs;
    }

    find(id) {
        if (this.id === id) {
            return this;
        }
        let rs;
        return this.children.some(node => {
            return (rs = node.find(id));
        })
            ? rs
            : null;
    }

    /*
     遍历节点
     return false的时候终止继续往下遍历
     */
    travel(func) {
        let rs = func(this);
        if (rs === false) {
            return;
        }
        this.children.forEach(node => {
            node.travel(func);
        });
    }

    filter(func) {
        return this.getAllChildren().filter(func);
    }

    contains(node) {
        return this.getAllChildren().some(n => n === node);
    }

    /*
     获取上下级
     */
    getParents() {
        let rs = [];
        let node = this;
        while (node) {
            rs.push(node);
            node = node.parent;
        }
        return rs;
    }

    getAllChildren() {
        let rs = [];
        rs.push(...this.children);
        this.children.map(node => {
            rs.push(...node.getAllChildren());
        });
        return rs;
    }

    /*
     增删改
     */
    modify(data = {}) {
        if (data.parent) {
            if (data.parent !== this.parent) {
                this.remove();
                // this.parentId
                data.parent && data.parent.addChild(this);
            }
            this.index = this.parent.children.indexOf(this);
        }
        this.checkInfo();
        // TODO 性能杀手
        this.children.map(node => node.modify());

        // TODO
        Object.assign(this, data);
    }

    addChild(node) {
        if (node.sequence !== undefined) {
            pushToArrayBySequence(node, this.children);
        } else {
            pushToArray(node, this.children);
        }

        this.leaf = false;
        node.parent = this;
        this.checkInfo();
        node.checkInfo();
    }

    removeChild(node) {
        node.parent = null;
        removeFromArray(node, this.children);
        this.checkInfo();
        node.checkInfo();
    }

    remove() {
        if (!this.parent) {
            return;
        }
        this.parent.removeChild(this);
    }

    /*
     各项数据检查
     */
    checkInfo() {
        this.parentId = this.parent ? this.parent.id : null;
        this.level = this.parent ? this.parent.level + 1 : null;
        this.leaf = !this.children.length;
        this.children.forEach((node, index) => {
            node.index = index;
        });
    }
}

// 唯物辩证式push数组
function pushToArray(element, array = []) {
    !~array.indexOf(element) && array.push(element);
}

// 根据sequence push数组
function pushToArrayBySequence(element, array = []) {
    let index;
    for (index = 0; index < array.length; index++) {
        if (array[index].sequence > element.sequence) {
            array.splice(index, 0, element);
            break;
        }
    }

    if (index === array.length) {
        array.push(element);
    }
}

// 从数组删除
function removeFromArray(element, array = []) {
    let i = array.indexOf(element);
    ~i && array.splice(i, 1);
}
